import React from 'react';

const TEMPERATURE_CONFIG: Record<string, { bg: string; text: string; label: string }> = {
  hot:      { bg: 'bg-red-500/20',    text: 'text-red-400',    label: 'Hot' },
  warm:     { bg: 'bg-orange-500/20',  text: 'text-orange-400', label: 'Warm' },
  lukewarm: { bg: 'bg-yellow-500/20', text: 'text-yellow-400', label: 'Lukewarm' },
  cold:     { bg: 'bg-blue-500/20',   text: 'text-blue-400',   label: 'Cold' },
  dead:     { bg: 'bg-slate-500/20',  text: 'text-slate-400',  label: 'Dead' },
};

interface TemperaturePillProps {
  temperature?: string | null;
  className?: string;
}

const TemperaturePill: React.FC<TemperaturePillProps> = ({ temperature, className = '' }) => {
  const normalized = (temperature ?? '').trim().toLowerCase();
  if (!normalized) return null;
  const config = TEMPERATURE_CONFIG[normalized];
  if (!config) return null;

  return (
    <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-semibold ${config.bg} ${config.text} ${className}`}>
      {config.label}
    </span>
  );
};

export default TemperaturePill;
export { TEMPERATURE_CONFIG };
